<template>
   <div id="div-main-pagination">
      <div class="d-flex flex-row justify-content-end">
         <div class="d-flex flex-row-reverse">
               <div class="py-2">
                  <b-dropdown id="coi-pagination-dropdown-per-page"
                     size="md" right
                     variant="outline-primary"
                     :text="pagination.perPage.toString()"
                     :disabled="queryInProgress"
                  >
                     <b-dropdown-item @click="() => { this.pagination.perPage =  '5' }"> 5</b-dropdown-item>
                     <b-dropdown-item @click="() => { this.pagination.perPage = '10' }">10</b-dropdown-item>
                     <b-dropdown-item @click="() => { this.pagination.perPage = '25' }">25</b-dropdown-item>
                     <b-dropdown-item @click="() => { this.pagination.perPage = '50' }">50</b-dropdown-item>
                  </b-dropdown>
               </div>
               <div class="p-2">
                  <b-pagination
                        class="float-right"
                        variant=""
                        v-if="(customerOrderCount / pagination.perPage ) >= 1"
                        v-model="pagination.currentPage"
                        :total-rows="customerOrderCount"
                        :per-page="pagination.perPage"
                        :first-number="true"
                        :last-number="true"
                        @input="paginationUserInput()"
                  ></b-pagination>
               </div>
               <div class="py-2 pr-0">
                  <span>Sortierung:</span>
                  <b-dropdown id="coi-dropdown-sort-list-items"
                     right
                     :text="this.selectedSortingOption.label"
                     variant="outline-primary"
                     :disabled="queryInProgress"
                  ><!-- dropdown -->
                     <b-dropdown-item
                        v-for="option in sortingOptions" :key="option.raw"
                        @click="sortCustomerOrdersBy(option)"
                     >{{option.label}}</b-dropdown-item>
                  </b-dropdown>
               </div>
               <div class="pt-3 pr-4">
                  <!--b-col v-if="this.queryResponse"-->
                  <b-col>
                     <span v-if="(0 === this.customerOrderCount) || (this.customerOrderCount)" class="pt-2">Treffer: {{this.customerOrderCount}}</span>
                     <span v-else>Treffer: <b-spinner style="width: 1rem; height: 1rem;" label="loading..." /></span>
                  </b-col>
               </div>
         </div>
      </div>
   </div>
</template>

<script>
import { useUserPreferenceStore } from '../../stores/UserPreferenceStore';

export default {
   setup(){
      const userPreferenceStore = useUserPreferenceStore();
      return {userPreferenceStore}
   },
   props: [ 'customerOrderCount', 'queryInProgress' ],
   data() {
      return {
         pagination: {
            orderBy: this.userPreferenceStore.coi.orderBy ? this.userPreferenceStore.coi.orderBy : "orderTime", /* mutable by user */
            perPage: this.userPreferenceStore.coi.personalPerPage ? this.userPreferenceStore.coi.personalPerPage : this.userPreferenceStore.coi.lightMode ? 10 : 5 ,    /* mutable by user */
            currentPage: 1, /* mutable by user & UI */
         },
         previousPerPage: 5,
         selectedSortingOption: { raw: 'id ASC', label: "ID, älteste zuerst" },
         sortingOptions: [
            { raw: 'id DESC', label:"ID, neuste zuerst" },
            { raw: 'id ASC', label: "ID, älteste zuerst" },
            { raw: 'orderTime DESC', label: "Bestelldatum, neuste zuerst" },
            { raw: 'orderTime ASC', label: "Bestelldatum, älteste zuerst" },
            { raw: 'deliveryDate DESC', label: "Versanddatum, neuste zuerst" },
            { raw: 'deliveryDate ASC', label: "Versanddatum, älteste zuerst" }
         ]
      }
   },
   watch: {
      pagination: {
         deep: true,
         handler: function(n, o) {
            // for some reason (n.perPage == o.perPage) is always true when
            // watcher is triggered, this is why I added previousPerPage
            // variable.
            if(n.perPage !== this.previousPerPage) {
               this.$emit('mutatedPagination', this.pagination);
            }
            this.previousPerPage = n.perPage;
            this.userPreferenceStore.coi.personalPerPage = n.perPage;
         }
      },
   },
   computed:{
   },
   methods: {
      sortCustomerOrdersBy(opt)
      {
         console.log("+++sortCustomerOrdersBy");
         this.selectedSortingOption = opt;
         this.pagination.orderBy = opt.raw;
         this.userPreferenceStore.updateCoi('orderBy', this.pagination.orderBy);
         this.$emit('mutatedPagination', this.pagination);
      },
      // method called by COIMain
      setCurrentPage(currentPage) {
         console.log(`+++COIPagination::setCurrentPage(${currentPage})`);
         this.pagination.currentPage = currentPage;
         // here we can choose NOT to emit mutatedPagination, and cause COIMain 
         // to send another request. Reactivity only makes sense if 
         // the triggered methods are caller agnostic and the 
         // affecting data is within component scope.
      },
      paginationUserInput() { //MOVED FROM MAIN
         console.log("called paginationUserInput");
         this.pagination = {
            orderBy: this.pagination.orderBy,
            perPage: this.pagination.perPage,
            currentPage: this.pagination.currentPage,
         };
         this.userPreferenceStore.updateCoi('personalPerPage', this.pagination.perPage);
         this.$emit('mutatedPagination', this.pagination);
      }
   },
   created() {
      this.$emit('mutatedPagination', this.pagination);
      if(this.userPreferenceStore.coi.orderBy){
         //to change the selectedSortingOption if an option was selected previous
         this.selectedSortingOption = this.sortingOptions.find(so => so.raw === this.userPreferenceStore.coi.orderBy)
      }
   }
}
</script>


